import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import Loading from '../Loading';

import style from './LoadingOverlay.module.scss';

const cx = classNames.bind(style);

const LoadingOverlay = ({ loading }) => {
  if (!loading) {
    return null;
  }
  return (
    <div className={cx('loading-overlay')} data-testid="loading-overlay">
      <Loading />
    </div>
  );
};

LoadingOverlay.propTypes = {
  loading: PropTypes.bool,
};

LoadingOverlay.defaultProps = {
  loading: false,
};

export default LoadingOverlay;
